import React, { useContext } from 'react'

import GeoContext from 'contexts/geoContext'
import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import { CuratedProductImage } from 'tripPlanner/components/CuratedItemSelection/CuratedProductImage'
import { useExperience } from 'tripPlanner/hooks/api/offer'
import { ExperienceItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: ExperienceItem
  onSelect: () => void
  isSelected: boolean
}
export function CuratedExperienceItemSelection({
  item,
  onSelect,
  isSelected,
}: Props) {
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)

  const { data: experience } = useExperience({
    experienceId: item?.code,
    currentCurrency,
    currentRegionCode,
  })

  const imgId = experience?.images[0]?.id
  const imgSrc = experience?.images[0]?.url
  return (
    <CuratedBaseItemSelection
      type={item.type}
      title={item.place.name}
      onSelect={onSelect}
      isSelected={isSelected}
      image={
        <CuratedProductImage
          item={item}
          imgId={imgId}
          imgSrc={imgSrc}
          placeId={'id' in item.place ? item.place.id : undefined}
        />
      }
    />
  )
}
